module.exports = new __parcel__URL__("artifact_0011.fe7821b4.png").toString();